// frontend/src/components/Layout/Header.jsx

import { Link, useNavigate } from 'react-router-dom';
import config from '../../config';
import api from '../../services/api';
import { useAuthStore } from '../../store/authStore.js';
import { ShoppingCart, User, LogOut, LogIn, UserPlus, Briefcase, ChevronDown, LayoutDashboard, Menu, X, ChevronLeft } from 'lucide-react';
import { useState, useRef, useEffect,React } from 'react';
import { cmsService } from '../../services/cmsService';
import NotificationBell from '../Notifications/NotificationBell'; // ✅ اضافه شد

export const Header = () => {
  const navigate = useNavigate();
  const { isAuthenticated, user, logout } = useAuthStore();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobileUserMenuOpen, setIsMobileUserMenuOpen] = useState(false);
  const [isMobileCategoriesOpen, setIsMobileCategoriesOpen] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const [menus, setMenus] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCategoriesDropdown, setShowCategoriesDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const categoriesDropdownRef = useRef(null);
  const mobileMenuRef = useRef(null);
  const [settings, setSettings] = useState(null);
  const [seoSettings, setSeoSettings] = useState(null);

  // دریافت تنظیمات سایت
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await cmsService.getSettings();
        setSettings(response.data);
      } catch (error) {
        console.error('Error fetching settings:', error);
        setSettings({ site_name: 'سان ایران' });
      }
    };
    fetchSettings();
  }, []);

  // دریافت تنظیمات سئو
  useEffect(() => {
    const fetchSEOSettings = async () => {
      try {
        const response = await api.get('/cms/settings/seo_settings/');
        setSeoSettings(response.data);
        if (response.data.default_meta_title) {
          document.title = response.data.default_meta_title;
        }
        if (response.data.default_meta_description) {
          const metaDesc = document.querySelector('meta[name="description"]');
          if (metaDesc) metaDesc.content = response.data.default_meta_description;
        }
      } catch (error) {
        console.error('Error fetching SEO settings:', error);
      }
    };
    fetchSEOSettings();
  }, []);

  // دریافت دسته‌بندی‌ها
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(config.getApiUrl('/products/categories/'));
        const data = await response.json();
        setCategories(data.results || data || []);
      } catch (error) {
        console.error('Error fetching categories:', error);
        setCategories([
          { id: 1, name: 'پنل خورشیدی', slug: 'solar-panels' },
          { id: 2, name: 'اینورتر', slug: 'inverter' },
          { id: 3, name: 'باتری', slug: 'batteries' },
          { id: 4, name: 'تجهیزات جانبی', slug: 'accessories' },
          { id: 5, name: 'استراکچر', slug: 'mounting-structures' },
          { id: 6, name: 'سانورتر', slug: 'sunverter' },
        ]);
      }
    };
    fetchCategories();
  }, []);

  // دریافت منوها
  useEffect(() => {
    const fetchMenus = async () => {
      try {
        const response = await cmsService.getMenus('header');
        let menuData = [];
        if (response.data) {
          if (Array.isArray(response.data)) {
            menuData = response.data;
          } else if (response.data.results) {
            menuData = response.data.results;
          } else {
            menuData = Object.values(response.data);
          }
        }

        if (!isAuthenticated) {
          menuData = menuData.filter(m => !m.requires_auth);
        }
        setMenus(menuData);
      } catch (error) {
        console.error('Error fetching menus:', error);
        setMenus([
          { id: 1, title: 'محصولات', url: '/products' },
          { id: 2, title: 'پکیج‌ها', url: '/packages' },
          { id: 3, title: 'نصاب‌ها', url: '/installers' },
          { id: 4, title: 'وبلاگ', url: '/blog' },
          { id: 5, title: 'درباره ما', url: '/about' },
          { id: 6, title: 'تماس با ما', url: '/contact' },
        ]);
      } finally {
        setLoading(false);
      }
    };
    fetchMenus();
  }, [isAuthenticated]);

  // بستن dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (categoriesDropdownRef.current && !categoriesDropdownRef.current.contains(event.target)) {
        setShowCategoriesDropdown(false);
      }
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
      if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target) && isMobileMenuOpen) {
        setIsMobileMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isMobileMenuOpen]);

  // تعداد سبد خرید
  useEffect(() => {
    const updateCartCount = () => {
      const cart = JSON.parse(localStorage.getItem('cart-storage') || '{"state":{"items":[]}}');
      const count = cart.state?.items?.reduce((total, item) => total + item.quantity, 0) || 0;
      setCartCount(count);
    };

    updateCartCount();
    window.addEventListener('storage', updateCartCount);
    const handleCartUpdate = () => updateCartCount();
    window.addEventListener('cart-updated', handleCartUpdate);

    return () => {
      window.removeEventListener('storage', updateCartCount);
      window.removeEventListener('cart-updated', handleCartUpdate);
    };
  }, []);

  // بستن منوی موبایل هنگام تغییر مسیر
  useEffect(() => {
    setIsMobileMenuOpen(false);
    setIsMobileUserMenuOpen(false);
    setIsMobileCategoriesOpen(false);
  }, [navigate]);

  const getRoleName = (role) => {
    switch (role) {
      case 'seller': return 'فروشنده';
      case 'installer': return 'نصاب';
      case 'admin': return 'ادمین';
      default: return 'مشتری';
    }
  };

  const logoUrl = settings?.site_logo ? config.getMediaUrl(settings.site_logo) : null;

  if (loading) {
    return (
      <header className="bg-white shadow-soft sticky top-0 z-50">
        <div className="container mx-auto px-4 py-3">
          <div className="flex items-center justify-between">
            <div className="text-2xl font-bold text-brand-600">سان ایران</div>
            <div className="animate-pulse flex gap-4">
              <div className="w-20 h-6 bg-gray-200 rounded"></div>
              <div className="w-20 h-6 bg-gray-200 rounded"></div>
            </div>
          </div>
        </div>
      </header>
    );
  }

  return (
    <header className="bg-white shadow-soft sticky top-0 z-50">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          {/* لوگو */}
          <Link to="/" className="flex items-center gap-2 shrink-0">
            {logoUrl ? (
              <img src={logoUrl} alt={settings?.site_name || 'سان ایران'} className="h-12 md:h-14 w-auto object-contain" />
            ) : (
              <span className="text-xl md:text-2xl font-bold text-brand-600">سان ایران</span>
            )}
          </Link>

          {/* دسکتاپ: منوی اصلی */}
          <div className="hidden md:flex items-center gap-6">
            <div className="relative" ref={categoriesDropdownRef}>
              <button
                onClick={() => setShowCategoriesDropdown(!showCategoriesDropdown)}
                className="text-gray-700 hover:text-brand-600 transition flex items-center gap-1"
              >
                دسته بندی
                <ChevronDown className={`w-4 h-4 transition-transform ${showCategoriesDropdown ? 'rotate-180' : ''}`} />
              </button>

              {showCategoriesDropdown && (
                <div className="absolute top-full right-0 mt-2 w-56 bg-white rounded-xl shadow-soft border border-gray-100 py-2 z-50">
                  {categories.map((category) => (
                    <Link
                      key={category.id}
                      to={`/category/${category.slug}`}
                      onClick={() => setShowCategoriesDropdown(false)}
                      className="block px-4 py-2 text-gray-700 hover:bg-brand-50 hover:text-brand-600 transition text-sm"
                    >
                      {category.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            {menus.map((menu) => (
              <Link
                key={menu.id}
                to={menu.url}
                className="text-gray-700 hover:text-brand-600 transition flex items-center gap-1"
              >
                {menu.title}
              </Link>
            ))}

            {isAuthenticated && (
              <Link to="/orders" className="text-gray-700 hover:text-brand-600 transition">
                سفارشات
              </Link>
            )}
          </div>

          {/* دکمه‌های سمت راست */}
          <div className="flex items-center gap-2 md:gap-4">
            {/* ✅ آیکون نوتیفیکیشن - فقط برای کاربران لاگین شده */}
            {isAuthenticated && (
              <div className="hidden md:block">
                <NotificationBell />
              </div>
            )}

            {/* سبد خرید */}
            <Link to="/cart" className="relative p-2 -m-2">
              <ShoppingCart className="w-5 h-5 md:w-6 md:h-6 text-gray-600 hover:text-brand-600 transition" />
              {cartCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center text-[10px]">
                  {cartCount > 99 ? '99+' : cartCount}
                </span>
              )}
            </Link>

            {/* دکمه منوی موبایل */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden p-2 -m-2 text-gray-600 hover:text-brand-600 transition"
            >
              {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>

            {/* دسکتاپ: منوی کاربری */}
            {isAuthenticated ? (
              <div className="hidden md:block relative" ref={dropdownRef}>
                <button
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  className="flex items-center gap-2 text-gray-700 hover:text-brand-600 transition"
                >
                  <User className="w-5 h-5 md:w-6 md:h-6" />
                  <span className="hidden lg:inline">{user?.username || user?.phone}</span>
                  <ChevronDown className={`w-4 h-4 transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`} />
                </button>

                {isDropdownOpen && (
                  <div className="absolute left-0 mt-2 w-56 bg-white rounded-xl shadow-soft border border-gray-100 py-2 z-50">
                    <div className="px-4 py-2 border-b border-gray-100">
                      <p className="text-sm font-medium text-gray-900">{user?.username || user?.phone}</p>
                      <p className="text-xs text-gray-500">{getRoleName(user?.role)}</p>
                    </div>

                    <Link to="/profile" className="block px-4 py-2 hover:bg-gray-50 transition text-sm">پروفایل من</Link>
                    <Link to="/orders" className="block px-4 py-2 hover:bg-gray-50 transition text-sm">سفارشات من</Link>

                    {user?.role === 'seller' && (
                      <Link to="/seller/dashboard" className="block px-4 py-2 hover:bg-gray-50 transition text-sm">داشبورد فروشنده</Link>
                    )}

                    {user?.role === 'installer' && (
                      <Link to="/installer/dashboard" className="block px-4 py-2 hover:bg-gray-50 transition text-sm">داشبورد نصاب</Link>
                    )}

                    {user?.role === 'admin' && (
                      <Link to="/admin" className="block px-4 py-2 bg-purple-50 text-purple-700 hover:bg-purple-100 transition text-sm font-medium">
                        پنل مدیریت
                      </Link>
                    )}

                    <div className="border-t border-gray-100 my-1"></div>
                    <button
                      onClick={() => { logout(); navigate('/'); }}
                      className="block w-full text-right px-4 py-2 text-red-600 hover:bg-red-50 transition text-sm"
                    >
                      خروج از حساب
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <div className="hidden md:flex items-center gap-2">
                <Link to="/login" className="text-gray-600 hover:text-brand-600 transition px-3 py-2 text-sm">
                  ورود
                </Link>
                <Link
                  to="/register"
                  className="bg-brand-500 text-white px-4 py-2 rounded-xl transition font-medium text-sm"
                >
                  ثبت نام
                </Link>
                <Link
                  to="/installer/register"
                  className="bg-secondary-600 hover:bg-secondary-700 text-white px-4 py-2 rounded-xl transition font-medium text-sm"
                >
                  ثبت نام نصاب
                </Link>
              </div>
            )}
          </div>
        </div>

        {/* منوی موبایل (اسلاید از راست) */}
        <div
          ref={mobileMenuRef}
          className={`fixed top-0 right-0 h-full w-80 bg-white shadow-xl z-50 transform transition-transform duration-300 ease-in-out md:hidden overflow-y-auto ${
            isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
          }`}
        >
          <div className="p-4 border-b flex justify-between items-center sticky top-0 bg-white z-10">
            <Link to="/" className="flex items-center gap-2" onClick={() => setIsMobileMenuOpen(false)}>
              <span className="text-xl font-bold text-brand-600">سان ایران</span>
            </Link>
            <button onClick={() => setIsMobileMenuOpen(false)} className="p-2">
              <X className="w-5 h-5" />
            </button>
          </div>

          <div className="p-4 pb-32">
            {/* ✅ آیکون نوتیفیکیشن در موبایل */}
            {isAuthenticated && (
              <div className="mb-4 p-3 bg-gray-50 rounded-xl flex items-center justify-between">
                <span className="text-sm font-medium text-gray-700">اعلان‌ها</span>
                <NotificationBell />
              </div>
            )}

            {/* منوی کاربری در موبایل - کشویی */}
            {isAuthenticated ? (
              <div className="mb-4">
                <button
                  onClick={() => setIsMobileUserMenuOpen(!isMobileUserMenuOpen)}
                  className="w-full flex items-center justify-between p-3 bg-gray-50 rounded-xl hover:bg-gray-100 transition"
                >
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-brand-100 rounded-full flex items-center justify-center">
                      <User className="w-5 h-5 text-brand-600" />
                    </div>
                    <div className="text-right">
                      <p className="font-medium text-gray-900">{user?.username || user?.phone}</p>
                      <p className="text-xs text-gray-500">{getRoleName(user?.role)}</p>
                    </div>
                  </div>
                  <ChevronLeft className={`w-5 h-5 text-gray-400 transition-transform ${isMobileUserMenuOpen ? '-rotate-90' : 'rotate-0'}`} />
                </button>

                {isMobileUserMenuOpen && (
                  <div className="mt-2 mr-4 space-y-1 border-r-2 border-gray-100 pr-3">
                    <Link
                      to="/profile"
                      onClick={() => setIsMobileMenuOpen(false)}
                      className="block px-4 py-3 text-gray-700 hover:bg-gray-50 rounded-lg transition"
                    >
                      پروفایل من
                    </Link>
                    <Link
                      to="/orders"
                      onClick={() => setIsMobileMenuOpen(false)}
                      className="block px-4 py-3 text-gray-700 hover:bg-gray-50 rounded-lg transition"
                    >
                      سفارشات من
                    </Link>
                    {user?.role === 'seller' && (
                      <Link
                        to="/seller/dashboard"
                        onClick={() => setIsMobileMenuOpen(false)}
                        className="block px-4 py-3 text-gray-700 hover:bg-gray-50 rounded-lg transition"
                      >
                        داشبورد فروشنده
                      </Link>
                    )}
                    {user?.role === 'installer' && (
                      <Link
                        to="/installer/dashboard"
                        onClick={() => setIsMobileMenuOpen(false)}
                        className="block px-4 py-3 text-gray-700 hover:bg-gray-50 rounded-lg transition"
                      >
                        داشبورد نصاب
                      </Link>
                    )}
                    {user?.role === 'admin' && (
                      <Link
                        to="/admin"
                        onClick={() => setIsMobileMenuOpen(false)}
                        className="block px-4 py-3 bg-purple-50 text-purple-700 rounded-lg transition"
                      >
                        پنل مدیریت
                      </Link>
                    )}
                    <div className="border-t border-gray-100 my-2"></div>
                    <button
                      onClick={() => { logout(); navigate('/'); setIsMobileMenuOpen(false); }}
                      className="w-full text-right px-4 py-3 text-red-600 hover:bg-red-50 rounded-lg transition"
                    >
                      خروج از حساب
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <div className="mb-6 flex flex-col gap-2">
                <Link
                  to="/login"
                  className="w-full bg-brand-600 text-white py-3 rounded-xl text-center font-medium"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  ورود
                </Link>
                <Link
                  to="/register"
                  className="w-full border border-brand-600 text-brand-600 py-3 rounded-xl text-center font-medium"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  ثبت نام مشتری
                </Link>
                <Link
                  to="/installer/register"
                  className="w-full bg-secondary-600 text-white py-3 rounded-xl text-center font-medium"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  ثبت نام نصاب
                </Link>
              </div>
            )}

            {/* دسته بندی در موبایل - کشویی */}
            <div className="mb-4">
              <button
                onClick={() => setIsMobileCategoriesOpen(!isMobileCategoriesOpen)}
                className="w-full flex items-center justify-between p-3 bg-gray-50 rounded-xl hover:bg-gray-100 transition"
              >
                <span className="font-medium text-gray-900">دسته‌بندی محصولات</span>
                <ChevronLeft className={`w-5 h-5 text-gray-400 transition-transform ${isMobileCategoriesOpen ? '-rotate-90' : 'rotate-0'}`} />
              </button>

              {isMobileCategoriesOpen && (
                <div className="mt-2 mr-4 space-y-1 border-r-2 border-gray-100 pr-3">
                  {categories.map((category) => (
                    <Link
                      key={category.id}
                      to={`/category/${category.slug}`}
                      onClick={() => setIsMobileMenuOpen(false)}
                      className="block px-4 py-3 text-gray-700 hover:bg-gray-50 rounded-lg transition"
                    >
                      {category.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            {/* سایر منوها */}
            <div className="space-y-1">
              {menus.map((menu) => (
                <Link
                  key={menu.id}
                  to={menu.url}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="block px-4 py-3 text-gray-700 hover:bg-gray-50 rounded-lg transition"
                >
                  {menu.title}
                </Link>
              ))}
            </div>
          </div>
        </div>

        {/* اوورلی برای بستن منو */}
        {isMobileMenuOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
            onClick={() => setIsMobileMenuOpen(false)}
          />
        )}
      </div>
    </header>
  );
};
